/**
 * Egen rabattkodslösning för Klarna Checkout.
 *
 * Standardformulärets submit-knapp postar checkout-formuläret och triggar betalningen.
 * Här applicerar/tar vi bort kupong via AJAX och triggar sedan "update_checkout" (jQuery-event)
 * så att WooCommerce + Klarna räknar om order review och ordern.
 *
 * Serverdelen ligger i:
 *   includes/woocommerce/action-functions/lw_checkout_coupon_field.php
 *   includes/woocommerce/action-functions/lw_checkout_coupon_ajax.php
 */

const $ = window.jQuery

function getEls() {
    const wrap = document.getElementById('lw-coupon')
    if (!wrap) return null
    return {
        wrap,
        input: wrap.querySelector('#lw-coupon-code'),
        applyBtn: wrap.querySelector('#lw-coupon-apply'),
        notices: wrap.querySelector('.lw-coupon-notices'),
        applied: wrap.querySelector('.lw-coupon-applied'),
        nonce: wrap.dataset.nonce,
    }
}

function setBusy(els, busy) {
    els.applyBtn.disabled = busy
    els.applyBtn.classList.toggle('disabled', busy)
    els.wrap.querySelectorAll('.lw-coupon-remove').forEach((b) => (b.disabled = busy))
}

// KCO lyssnar på jQuery-eventet "update_checkout" och uppdaterar då order review + Klarna-ordern.
function refreshCheckout() {
    if ($) $(document.body).trigger('update_checkout')
}

async function postCoupon(action, code) {
    const els = getEls()
    if (!els) return

    const body = new URLSearchParams({
        action,
        nonce: els.nonce,
        coupon_code: code || '',
    })

    setBusy(els, true)
    try {
        const res = await fetch(window.liGlobal.ajaxUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body,
        })
        const json = await res.json()
        const data = (json && json.data) || {}

        els.notices.innerHTML = data.notices || ''
        els.applied.innerHTML = data.coupons || ''

        if (json && json.success) {
            els.input.value = ''
        }

        // Räkna om totaler och Klarna-ordern oavsett apply/remove.
        refreshCheckout()
    } catch (err) {
        els.notices.innerHTML =
            '<div class="woocommerce-error">' + (window.liGlobal.couponError || 'Something went wrong. Please try again.') + '</div>'
    } finally {
        const cur = getEls()
        if (cur) setBusy(cur, false)
    }
}

function init() {
    const els = getEls()
    if (!els) return

    els.applyBtn.addEventListener('click', () => {
        postCoupon('lw_apply_coupon', els.input.value.trim())
    })

    // Enter i inputfältet ska applicera kupongen, inte posta checkout-formuläret.
    els.input.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter') return
        e.preventDefault()
        postCoupon('lw_apply_coupon', els.input.value.trim())
    })

    // Ta bort kupong (delegerat, då listan ritas om vid varje uppdatering).
    els.wrap.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('.lw-coupon-remove')
        if (!removeBtn) return
        e.preventDefault()
        postCoupon('lw_remove_coupon', removeBtn.dataset.coupon)
    })
}

document.addEventListener('DOMContentLoaded', init)
